import { render } from "./mini.vue?vue&type=template&id=4691f817&scoped=true&ts=true"
import script from "./mini.vue?vue&type=script&lang=tsx"
export * from "./mini.vue?vue&type=script&lang=tsx"

import "./mini.vue?vue&type=style&index=0&id=4691f817&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4691f817"]])

export default __exports__